import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {GetDocumentDetailRequestInterface} from 'src/app/interfaces/document-request.interface';
import {PracticesDirectoryRequestInterface, PracticesDirectoryResponseInterface} from 'src/app/interfaces/plans.interface';
import {StateRequestInterface} from 'src/app/interfaces/state-request.interface';
import {GrievanceRequestInterface} from 'src/app/interfaces/grievance-request.interface';
import {HttpError} from 'src/app/models/http-error.model';
import {ContactUsRequestInterface} from 'src/app/interfaces/contact-us-request.interface';

@Injectable({
  providedIn: 'root'
})

export class PlansService {
  private _httpClient = inject(HttpClient);

  public getContactDetails(branding: string): Observable<any> {
    const url: string = `${environment.apiUrl}${environment.treatmentApi}practice/get-help-information?hint=` + branding;
    return this._httpClient.get(url);
  }

  public getPlanDetails(options: StateRequestInterface): Observable<any> {
    const url: string = `${environment.widgetApi}/npm/get-template-plan-options`;
    return this._httpClient.get(url + '?organization=' + options.Organization + '&planPrefix=' + options.PlanPrefix + '&state=' + options.State);
  }

  public getSellableStatesByPlan(options: string): Observable<any> {
    const url: string = `${environment.apiUrl}sales/plans/get-sellable-states-by-plan`;
    return this._httpClient.get(url+'?planName=' + options);
  }

  public getPlanOptionsByPractice(practiceId: string): Observable<any> {
    const url: string = `${environment.widgetApi}/npm/get-template-plan-options`;
    return this._httpClient.get(url + '?practiceId=' + practiceId);
  }

  public getDocumentDetails(request: GetDocumentDetailRequestInterface): Observable<any > {
    const url = `${environment.apiUrl}${environment.treatmentApi}member/get-document-details`;
    return this._httpClient.post<string>(url, request);
  }

  public sendGrievanceForm(request: GrievanceRequestInterface): Observable<any > {
    const url = `${environment.salesApiUrl}services/send-grievance-email`;
    return this._httpClient.post<string>(url, request);
  }

  public getPracticesDirectory(request: PracticesDirectoryRequestInterface): Observable<PracticesDirectoryResponseInterface | HttpError> {
    const url = `${environment.apiUrl}${environment.treatmentApi}practices/get-directory`;
    return this._httpClient.post<PracticesDirectoryResponseInterface>(url, request);
  }

  public getHomePageData(request: any): Observable<any> {
    const url: string = `${environment.apiUrl}sales/purchase/portal/get-marketing-details`;
    return this._httpClient.get(url+'?PageName='+request.pageName+'&benefitPlanTemplateId='+request.planId);
  }

  public sendContactUs(request: ContactUsRequestInterface): Observable<any> {
    const url: string = `${environment.apiUrl}sales/contact-us/send-email`;
    return this._httpClient.post<any>(url, request);
  }
}
